<template>
  <div class="fb">
    <template v-if="entityFilters.length">
      <Worklist_FilterBar
        v-for="(f, i) in entityFilters"
        :key="'entities-' + f.name"
        class="fb-entities"
        :storage-key="f.storage_key || `page_filter_${f.name}`"
        :show-my-practices="f.my_practices !== false"
        @filter-changed="pickMany(f.name, $event)"
      >
        <template v-if="i === 0" #filters>
          <FilterControl
            v-for="pf in plainFilters"
            :key="pf.name"
            :filter="pf"
            :value="values[pf.name]"
            inline
            @change="$emit('change', pf.name, $event)"
          />
        </template>
      </Worklist_FilterBar>
    </template>
    <FilterControl
      v-for="f in entityFilters.length ? [] : plainFilters"
      :key="f.name"
      :filter="f"
      :value="values[f.name]"
      @change="$emit('change', f.name, $event)"
    />
  </div>
</template>

<script>
import Worklist_FilterBar from '@/components/widgetcomponents/Worklist_FilterBar.vue';
import FilterControl from './FilterControl.vue';

export default {
  name: 'FilterBar',
  components: { Worklist_FilterBar, FilterControl },
  props: {
    filters: { type: Array, required: true },
    values: { type: Object, default: () => ({}) },
  },
  emits: ['change'],
  computed: {
    entityFilters() {
      return this.filters.filter((f) => f.type === 'entities');
    },
    plainFilters() {
      return this.filters.filter((f) => f.type !== 'entities');
    },
  },
  methods: {
    pickMany(name, payload) {
      const ids = Object.values((payload && payload.entity_filters) || {}).flat().map(Number).filter(Boolean);
      const mine = !!(payload && payload.my_practices);
      this.$emit('change', name, ids.length || mine ? { entity_ids: ids, my_practices: mine } : '');
    },
  },
};
</script>

<style scoped>
.fb { display: flex; gap: 10px; flex-wrap: wrap; }
.fb-entities { flex-basis: 100%; }
</style>
